export default "__VITE_ASSET__MlXIXVL8__"